import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const MolecularProfileUrl = ({ gene, variant, molecularProfileUrl }) => {
  return molecularProfileUrl ? (
    <div className="varsome-horiz-list-item">
      <div className="varsome-horiz-list-label">
        Molecular Profile Expression
      </div>
      <div className="varsome-horiz-list-value">
        <a target="_blank" href={getVarsoUrl(molecularProfileUrl)}>
          {`${gene} ${variant}`}
        </a>
      </div>
    </div>
  ) : null;
};

MolecularProfileUrl.propTypes = {
  molecularProfileUrl: PropTypes.string,
  gene: PropTypes.string,
  variant: PropTypes.string,
};

MolecularProfileUrl.defaultProps = {
  molecularProfileUrl: null,
  gene: null,
  variant: null,
};

export default MolecularProfileUrl;
